
<!--  v-if is in case the form async fetch hasn't been received yet-->
<loading :loading="!Boolean(handler.formElement)">
  <template #loading>
    <collapsible-section
      :control-name="dropdownControlId"
      :id="dropdownControlId"
      :is-open="false"
      disabled
      class="collapse-item"
    >
      <template #section-header>
        <xpinner />
      </template>
    </collapsible-section>
  </template>
  <template #loaded>
    <collapsible-section
      v-if="handler.formElement"
      class="collapse-item"
      :id="`step_${handler.formElement.id}-${dropdownControlId}`"
      :control-name="`${handler.formElement.referenceNameOrDefault}Collapse`"
      :is-open="isOpen(hasFormElementMatch)"
    >
      <template #section-header>
        <row>
          <prefix>
            <icon :glyph="varIOClass(handler.variable)" />
          </prefix>
          <column>
            {{ handler.rootHeaderOrDefault }}
          </column>
        </row>
      </template>

      <template #section-contents>
        <form-element-container-data
          v-for="section in formElementSections"
          :handler="handler"
          :element-container="section.formElement"
          recurse
          :parent-tree-context="computedChildTreeContext"
          :key="section.client_id"
          @select="el => select(handler.selectFormElement(el, section.workflowStep))"
        >
          <template #after-elements>
            <collapsible-section
              v-for="section in userDataSections"
              :key="section.type"
              :id="`stepUserData-${handler.formElement.id}-${dropdownControlId}`"
              :control-name="`stepUserData-${handler.formElement.id}-${dropdownControlId}`"
              :is-open="false"
            >
              <template #section-header>
                <row>
                  <column>
                    {{ section.header }}
                  </column>
                </row>
              </template>

              <template #section-contents>
                <field-item
                  v-for="field in section.fields"
                  :key="field.id"
                  :disabled="handler.isDisabled(field, parentTreeContext)"
                  @click="select(section.select(field, section.type))"
                >
                  <row>
                    <prefix>
                      <icon :glyph="modelTypeIcon(field.modelType)"/>
                    </prefix>
                    <column>
                      {{ field.label }}
                    </column>
                  </row>
                </field-item>
              </template>
            </collapsible-section>
          </template>
        </form-element-container-data>
      </template>
    </collapsible-section>
  </template>
</loading>
